<div class="trusted-client-logo-container">
<img src="{{clientImage}}" alt="{{clientName}}" />
</div>
